<template>
  <div class="departmentList">
    <v-flex xs3 storeListSearch>
      <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field>
      <br/>
    </v-flex>
    <v-data-table loading="true" :headers="headers" :items="departmentList" ref="sortableTable" :search="search"
                  hide-actions disable-initial-sort class="elevation-1">
      <template slot="items" slot-scope="props">
        <tr class="sortableRow" id="rows">
          <td width="30%">{{ props.item.name }}</td>
          <td width="30%" >{{ props.item.description }}</td>
          <td width="20%" >{{ fncGetLocalizedDateFromUTC(props.item.created_on) }}</td>
          <td width="10%" v-if="objAuthorize.privileges.indexOf('DEPARTMENTAL_MODULE') !== -1" ><a
            @click.prevent="fncShowEdit(props.item)"><i class="material-icons">edit</i></a></td>
          <td width="10%" v-if="objAuthorize.privileges.indexOf('DEPARTMENTAL_MODULE') !== -1" ><a
            @click.prevent="fncDepartmentDelete(props.item)"><i class="material-icons">delete</i></a></td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>

import {mapGetters} from 'vuex';

export default {
  name: 'RoleList',
  intRoleEdit: 0,
  data() {
    return {
      search: '',
      headers: [
        {text: 'Name', value: 'name', width: '30%'},
        {text: 'Description', value: 'description', width: '30%'},
        {text: 'Created On', value: 'created_on', width: '20%'},
        {text: 'Edit', value: 'edit', width: '10%'},
        {text: 'Delete', value: 'delete', width: '10%'}
      ]
    }
  },
  methods: {
    fncGetLocalizedDateFromUTC(theDate) {

      var options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "numeric",
        minute: "numeric",
        hour12: false
      };

      var newDate = new Date(Date.parse(theDate + ' UTC'));
      var dateString = newDate.toLocaleString("en", options);
      var objDate = dateString.split(',');

      var newDate = objDate[0].split('/');

      var strDate = newDate[2] + '-' + newDate[0] + '-' + newDate[1] + ' ' + objDate[1];

      return strDate;

    },
    fncShowEdit(department) {
      this.$store.commit('setDepartmentLoader', true);
      this.$store.commit({
        type: 'setObjDepartmentEdit',
        depId: department.id,
        regions: this.userRegions
      });
      this.$store.dispatch({
        type: 'fncBranchRanges',
        mode: 'edit',
        departmentName: department.name,
        departmentId: department.id
      })

      //this.$store.dispatch('fncBranchRanges', 'edit');
      var modalDetails = {
        title: 'Edit Department - ' + department.name,
        component: 'modal-department-edit',
        mstate: true
      };
      this.$store.commit({
        type: 'setModal',
        details: modalDetails
      });
    },
    fncDepartmentDelete(department) {
      if (department.linked == true) {
        alert('The department can not be deleted as it has users linked to it');
      } else {
        var confirmDelete = confirm('Are you sure you would like to remove ' + department.name + '?');
        if (confirmDelete === true) {
          this.$store.dispatch({
            type: 'fncDepartmentDelete',
            departmentId: department.id
          });
        }
      }
    },
  },
  computed: {
    ...mapGetters([
      'userRoles',
      'objRoleEdit',
      'objAuthorize',
      'departmentList',
      'userRegions'
    ])
  },
  beforeMount() {
    this.$store.dispatch('fncPopulateDepartments');
    this.$store.dispatch('fncPopulateUserRegions');
  },
  mounted() {
    if (this.departmentList.length > 0 && this.departmentList[0].id == '') {
      this.departmentList.shift();
    }
  },
  watch: {
    branchList() {
      if (this.departmentList[0].id = '') {
        this.departmentList.shift();
      }
    }
  }
}
</script>

<style scoped>
@import '../shared/assets/css/shared.css';
</style>
